export default [
  {
    path: "/programme/:programmeId/",
    name: "ApplicationContainer",
    component: () =>
      import(
        /* webpackChunkName: "applications" */ "../views/ApplicationContainer.vue"
      ),
    props: true,
    children: [
      {
        path: "housejob/",
        name: "ApplicationFormHousejob",
        component: () =>
          import(
            /* webpackChunkName: "applications" */ "../views/application_forms/ApplicationFormHousejob.vue"
          ),
        props: true,
      },
      {
        path: "mdcat/",
        name: "ApplicationFormMDCAT",
        component: () =>
          import(
            /* webpackChunkName: "applications" */ "../views/application_forms/ApplicationFormMDCAT.vue"
          ),
        props: true,
      },
      {
        path: "regular/",
        name: "ApplicationFormWithoutMDCAT",
        component: () =>
          import(
            /* webpackChunkName: "applications" */ "../views/application_forms/ApplicationFormNew.vue"
          ),
        props: true,
      },
      {
        path: "new/",
        name: "ApplicationFormNew",
        component: () =>
          import(
            /* webpackChunkName: "applications" */ "../views/application_forms/ApplicationFormNew.vue"
          ),
        props: true,
      },
    ],
  },
];
